












































import { Component, Vue, Watch } from "vue-property-decorator";
import Company from "@/models/company";
import { LayoutModule } from "@/store/layout";
import CompanyAPI from "@/services/companies";
import TableActions from "@/components/TableActions.vue";
import { Meta, QueryParams } from "@/models/general";
import { get } from "lodash";

@Component({
  components: { TableActions },
})
export default class Companies extends Vue {
  headers = [
    {
      text: this.$t("companies.model.name"),
      sortable: false,
      value: "name",
    },
    {
      text: this.$t("companies.model.legalName"),
      sortable: false,
      value: "legalName",
    },
    {
      text: this.$t("companies.model.businessName"),
      sortable: false,
      value: "businessName",
    },
    {
      text: "",
      value: "id",
    },
  ];

  companies: Company[] = [];
  meta: Meta = new Meta();
  pagination = {};
  loading = true;
  searchQuery = "";

  created(): void {
    this.getCompanies();
  }

  async getCompanies(): Promise<void> {
    this.loading = true;
    try {
      const params: QueryParams = {
        page: {
          number: this.meta.pagination.current,
          size: this.meta.pagination.size,
        },
      };

      this.searchQuery && this.searchQuery !== ""
        ? (params.search = this.searchQuery)
        : null;

      const r = await CompanyAPI.getCompanies(params);
      this.companies = r.data;
      this.meta = new Meta(r.meta);
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

  editCompany(company: Company): void {
    this.$router.push({
      name: "editCompany",
      params: { id: String(company.id) },
    });
  }

  deleteCompany(id: string): void {
    LayoutModule.setDialogTitle("companies.delete");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        LayoutModule.showLoader();
        await CompanyAPI.deleteCompany(id);
        LayoutModule.hideLoader();
        const idx = this.companies.findIndex((c: Company) => {
          return c.id === id;
        });
        this.companies.splice(idx, 1);
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");

    this.getCompanies();
  }

  @Watch("searchQuery")
  async search(): Promise<void> {
    this.getCompanies();
  }
}
